import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { MoreVertRounded } from '@mui/icons-material';
import { CircularProgress, IconButton, Menu, Typography } from '@mui/material';
import { useState } from 'react';
import { DashboardHeaderMenuItems } from './DashboardHeaderMenuItems';

export const DashboardHeaderMenu = () => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);
  const isUpdating = useDashboardStore(
    ({ visual }) => visual.isUpdateDashboardInProgress,
  );

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  if (!dashboard.id) {
    return null;
  }

  const isMenuOpen = Boolean(menuAnchor);

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  };
  const closeMenu = () => {
    setMenuAnchor(null);
  };

  return (
    <>
      {isUpdating ? (
        <Typography color="text.disabled">
          <CircularProgress size={40} color="inherit" />
        </Typography>
      ) : (
        <IconButton
          color="primary"
          onClick={openMenu}
          aria-label="Dashboard more actions"
        >
          <MoreVertRounded />
        </IconButton>
      )}
      <Menu anchorEl={menuAnchor} open={isMenuOpen} onClose={closeMenu}>
        <DashboardHeaderMenuItems closeMenu={closeMenu} />
      </Menu>
    </>
  );
};
